
<script>
	import listBase from '@_system/components/base/list.vue'
	import distributionIndex from './distribution/index.vue';
	export default {
		extends: listBase,
		name: 'crmcustomerseaIndex',
		render(h) {
			this.$slots.plug = [
				<distribution-index customers={this.customers} title={this.distributiontitle} onSubmit={this.distributionSubmit} ref="distribution" />
			]
			return listBase.render.call(this, h)
		},		
		props: {

		},
		data() {
			return {
				moduleName: 'crmcustomersea',
				windowName: '客户公海',
				exportData: [],
				currentrow:null,
				customers:[],
				distributionShow:false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			batchdistribution(){
				let data = this.getGrid().getCheckboxRecords()
				let customers = []
				data.forEach((item)=>{
					customers.push({
						crmcustomerid:item.id,
						crmcustomercode:item.code,
						crmcustomername:item.name,
					})
				})
				if(customers.length!=0){
					this.customers = customers
					this.distributiontitle = '批量分配'
					this.$refs.distribution.modalShow()
				}else{
					this.$message.error('请选择客户')
				}
			},
			distribution(row) {
				this.customers = [{
					crmcustomerid:row.id,
					crmcustomercode:row.code,
					crmcustomername:row.name,
				}]
				this.distributiontitle = '旺旺ID'+ row.buyerid
				this.$refs.distribution.modalShow()
			},
			distributionSubmit(){
				this.$refs.distribution.modalHide()
				this.customreload()
			},

		},
		components: {
			distributionIndex
		}
	}
</script>
